import React, { useState, useEffect } from 'react'
import { useFetch } from './useFetch'
import Follower from './Follower'

function App() 
{
  const { loading, data } = useFetch();
  const [page, setPage] = useState(0);
  const [ followers , setFollowers ] = useState([]);
  const handlePrev = ()=>
  {
    setPage(page-1);
    if(page === 0)
    {
      setPage(data.length-1);
    }
  }

  const handleNext = ()=>
  {
    setPage(page+1);
    if(page === data.length-1)
    {
      setPage(0);
    }
  }

  useEffect(()=>
  {
    if(loading)
    {
      return;
    }
    setFollowers(data[page]);
  },[loading, page])
  return (
  <main>
    <div className = "section-title">
      <h1> { loading ? 'Loading....' : 'Github Users'}</h1>
      <div className = "underline"></div>
    </div>
    <section className = "followers">
      <div className = "container">
        {
          followers.map((follower)=>
          {
            return <Follower {...follower} key = {follower.id} />
          })
        }
      </div>
      { 
        !loading && (
        <div className="btn-container">
          <button className="prev-btn" onClick={handlePrev}>Prev</button>
          {
            data.map((_, index)=>
            {
              return <button key = {index} className={`page-btn ${ index === page ? 'active-btn' : null }`} onClick={()=> {setPage(index)}}>{index+1}</button>
            })
          }
          <button className="next-btn" onClick={handleNext}>Next</button>
        </div>)
      }
    </section>
  </main>);
}

export default App;
